export default "__VITE_ASSET__10a838aa__"